/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ConnectedAccount
 */
export interface ConnectedAccount {
    /**
     *
     * @type {number}
     * @memberof ConnectedAccount
     */
    readonly id: number;
    /**
     *
     * @type {string}
     * @memberof ConnectedAccount
     */
    readonly provider: string;
    /**
     *
     * @type {string}
     * @memberof ConnectedAccount
     */
    readonly uid: string;
    /**
     *
     * @type {Date}
     * @memberof ConnectedAccount
     */
    readonly dateJoined: Date;
    /**
     *
     * @type {string}
     * @memberof ConnectedAccount
     */
    readonly email: string;
    /**
     *
     * @type {string}
     * @memberof ConnectedAccount
     */
    readonly name: string;
    /**
     *
     * @type {string}
     * @memberof ConnectedAccount
     */
    readonly screenName: string;
    /**
     *
     * @type {string}
     * @memberof ConnectedAccount
     */
    readonly login: string;
    /**
     *
     * @type {string}
     * @memberof ConnectedAccount
     */
    readonly profileUrl: string;
}

/**
 * Check if a given object implements the ConnectedAccount interface.
 */
export function instanceOfConnectedAccount(value: object): value is ConnectedAccount {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('uid' in value) || value['uid'] === undefined) return false;
    if (!('dateJoined' in value) || value['dateJoined'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('screenName' in value) || value['screenName'] === undefined) return false;
    if (!('login' in value) || value['login'] === undefined) return false;
    if (!('profileUrl' in value) || value['profileUrl'] === undefined) return false;
    return true;
}

export function ConnectedAccountFromJSON(json: any): ConnectedAccount {
    return ConnectedAccountFromJSONTyped(json, false);
}

export function ConnectedAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectedAccount {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'provider': json['provider'],
        'uid': json['uid'],
        'dateJoined': (new Date(json['date_joined'])),
        'email': json['email'],
        'name': json['name'],
        'screenName': json['screen_name'],
        'login': json['login'],
        'profileUrl': json['profile_url'],
    };
}

  export function ConnectedAccountToJSON(json: any): ConnectedAccount {
      return ConnectedAccountToJSONTyped(json, false);
  }

  export function ConnectedAccountToJSONTyped(value?: Omit<ConnectedAccount, 'id'|'provider'|'uid'|'date_joined'|'email'|'name'|'screen_name'|'login'|'profile_url'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
